const handler = async (el) => {
    window.dispatchEvent(new CustomEvent('ajax.submitting'));

    if (el.dataset.successCallback) {
        window.dispatchEvent(new CustomEvent(`ajax.submitting.${el.dataset.successCallback}`));
    }

    const jsonData = el.dataset.json;

    const config = {};

    config.method = el.dataset.method || 'GET';

    if (jsonData) {
        config.body = jsonData;

        config.headers = {
            'Content-Type': 'application/json',
        };
    }

    const response = await fetch(el.dataset.action, config);

    if (response.ok) {
        window.dispatchEvent(new CustomEvent('ajax.success', { detail: { response } }));
        if (el.dataset.successCallback) {
            window.dispatchEvent(
                new CustomEvent(`ajax.success.${el.dataset.successCallback}`, {
                    detail: { response },
                })
            );
        }
    } else {
        window.dispatchEvent(new CustomEvent('ajax.error', { detail: { response } }));

        if (el.dataset.successCallback) {
            window.dispatchEvent(
                new CustomEvent(`ajax.error.${el.dataset.errorCallback}`, {
                    detail: { response },
                })
            );
        }
    }
};

export const ajaxFormListener = () => {
    const ajaxElements = [...document.querySelectorAll('.js-send-ajax')].filter(
        (el) => !el.dataset.ajaxFormInitialized
    );

    ajaxElements.forEach((el) => {
        if (el.tagName === 'INPUT') {
            el.addEventListener('change', () => {
                handler(el);
            });
        } else {
            el.addEventListener('click', (e) => {
                e.preventDefault();

                handler(el);
            });
        }

        el.dataset.ajaxFormInitialized = true;
    });
};
